var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5039_12118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6853 0.133301H23.6187C23.6187 5.86663 28.2853 10.5333 34.0187 10.5333H38.2853V14.6C38.2853 20.3333 42.952 25 48.6853 25V2.1333C48.6853 0.999967 47.752 0.133301 46.6853 0.133301Z",
    fill: "#0082FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2853 11.6001H12.2186C12.2186 17.3334 16.8853 22.0001 22.6186 22.0001H26.8853V26.1334C26.8853 31.8668 31.552 36.5334 37.2853 36.5334V13.6668C37.2853 12.5334 36.352 11.6001 35.2853 11.6001Z",
    fill: "url(#paint0_linear_5039_12118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8853 23.0669H0.818604C0.818604 28.8002 5.48527 33.4669 11.2186 33.4669H15.4186V37.5336C15.4186 43.2669 20.0853 47.9336 25.8186 47.9336V25.0002C25.8853 24.0002 24.9519 23.0669 23.8853 23.0669Z",
    fill: "url(#paint1_linear_5039_12118)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5039_12118",
    x1: 36.7737,
    y1: 11.6486,
    x2: 26.967,
    y2: 21.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0050D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5039_12118",
    x1: 26.0169,
    y1: 23.1985,
    x2: 14.6769,
    y2: 34.2318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0050D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5039_12118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.751953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraLogo);
export default __webpack_public_path__ + "static/media/jira_logo.a0415073.svg";
export { ForwardRef as ReactComponent };